import { useEffect, useState } from 'react';
import useVideoContext from '../useVideoContext/useVideoContext';
import type { AgoraParticipantLike } from '../../types';
import useParticipants from '../useParticipants/useParticipants';

export default function useScreenShareParticipant(): AgoraParticipantLike | null {
  const { room, localTracks } = useVideoContext();
  const participants = useParticipants();
  const [screenShareParticipant, setScreenShareParticipant] = useState<AgoraParticipantLike | null>(null);

  useEffect(() => {
    if (!room) {
      setScreenShareParticipant(null);
      return;
    }
    const update = () => {
      const all = [room.localParticipant, ...participants];
      const who = all.find(p => p.screenTrack || p.getPublications().some((pub: { trackName?: string }) => pub.trackName?.includes('screen')));
      setScreenShareParticipant(who ?? null);
    };
    update();
    const client = room.client;
    client.on('user-published', update);
    client.on('user-unpublished', update);
    client.on('user-left', update);
    return () => {
      client.off('user-published', update);
      client.off('user-unpublished', update);
      client.off('user-left', update);
    };
    // Local screen-share toggles may not emit 'user-published' on local client; rerun when local tracks change.
  }, [room, localTracks, participants]);

  return screenShareParticipant;
}
